import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-general-message',
  templateUrl: './dialog-general-message.component.html',
  styleUrls: ['./dialog-general-message.component.scss']
})
export class DialogGeneralMessageComponent implements OnInit {
  @Input() message: string;
  @Input() title: string;
  @Input() icon: string;
  @Input() mainBtn: string;
  @Input() img: string;
  @Input('autoClose')
  set autoClose(second: number) {
    this.countdown = second;
    const interval = setInterval(() => {
      if (this.countdown <= 0){
        clearInterval(interval);
        this.dialogRef.close()
      }
      this.countdown -= 1;
    }, 1000);
  }
  @Output() onUpdateState: EventEmitter<any> = new EventEmitter();

  public countdown;


  constructor(@Inject(MD_DIALOG_DATA) public data: any,
              public dialogRef: MdDialogRef<DialogGeneralMessageComponent>) { }

  ngOnInit() {
    const { title, message, icon, mainBtn } = this.data;
    this.title = title;
    this.message = message;
    this.icon = icon;
    this.mainBtn = mainBtn;
  }

  handleCloseDialog() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-general-message/dialog-general-message.component.ts